import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { AppAddBarComponent, AppCalendarComponent } from './../../components';

import { ReservationModel, UserModel } from './../../models';
import { ReservationService, EventsService, UserService } from './../../services';

import { CalendarEvent } from 'angular-calendar';

import { RemoveDialogComponent } from './../../components';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    templateUrl: './dashboard-view.component.html',
    styleUrls: ['./dashboard-view.component.scss']
})

export class DashboardViewComponent {
    @ViewChild(AppAddBarComponent) addBarComp: AppAddBarComponent;    

    dialogRef: MatDialogRef<RemoveDialogComponent> | null;

    reservation = new ReservationModel();

    startDate: Date;    
    endDate: Date;
    startHr: string = "12";
    endHr: string = "13";
    startMin: string = "00";
    endMin: string = "00";

    user = new UserModel();

    isUpdate: boolean = false;
    barView: string;

    constructor(private router: Router,
                private eventsService: EventsService,
                private reservationService: ReservationService,
                private userService: UserService,
                private dialog: MatDialog) {        

        router.events.subscribe( res => {
            if (res instanceof NavigationEnd) {
                this.barView = router.url.substring(11);
                console.log(this.barView);
            }
        })
    }

    ngOnInit() {
        this.addReservationListener();
        this.eventTimeChangeListener();
        this.hourClickedListener();

        this.addUserListener();
    }

    toggleAddBar(open: boolean) {
        open ? this.addBarComp.barToggler(true) : this.addBarComp.barToggler(false);
    }

    addReservationListener() {
        this.eventsService.addReservationEmitter.subscribe((res: Date) => {
            this.isUpdate = false;

            if (res == null) {                                
                this.startDate = new Date;
                this.endDate = new Date;
                this.toggleAddBar(true);   
            } else {
                this.startDate = res;
                this.endDate = res;
                this.toggleAddBar(true);
            }
        })
    }

    getUserById(id: string) {
        this.userService.getById(id).subscribe(res => {
            if (res) {
                this.user = res;
            }
        })
    }

    addUserListener() {
        this.eventsService.addUserEmitter.subscribe(id => {
            if (id) {
                this.isUpdate = true;
                this.getUserById(id);
                console.log(this.user);
                this.toggleAddBar(true);
            } else {
                this.isUpdate = false;
                this.toggleAddBar(true);
            }
        })
    }

    refreshCal() {
        this.eventsService.refreshCal();
    }

    refreshUsers() {
        this.eventsService.refreshUsers();
    }

    numberCorrection(value: string, variable?: string) {
        var valueLength = value.toString().length;
        var valueNumber = Number.parseInt(value);

        var correctedValue = value;

        correctedValue = (valueLength < 2) ? "0" + correctedValue : correctedValue;

        if (variable) {
            correctedValue = (valueNumber > 23 || valueNumber < 0) && variable.includes("Hr") ? correctedValue = "23" : correctedValue;
            correctedValue = (valueNumber > 59 || valueNumber < 0) && variable.includes("Min") ? correctedValue = "59" : correctedValue;

            this[variable] = correctedValue;
        } else return correctedValue;                            
    }

    hourClickedListener() {
        this.eventsService.hourClickedEmitter.subscribe((res: Date) => {
            this.isUpdate = false;

            this.reservation = new ReservationModel();
            this.startDate = res;
            this.startHr = this.numberCorrection(res.getHours().toString());
            this.startMin = this.numberCorrection(res.getMinutes().toString());
            this.endDate = res;
            this.endHr =  this.numberCorrection((res.getHours() + 1).toString());
            this.endMin = this.numberCorrection(res.getMinutes().toString());

            this.toggleAddBar(true);
        })
    }

    eventTimeChangeListener() {
        this.eventsService.eventTimeActionEmitter.subscribe((res: CalendarEvent) => {
            if (res) {
                this.isUpdate = true;                
                
                this.reservation.title = res.title;
                this.reservation.id = res.meta.id;
                this.reservation.start = res.start;
                this.reservation.end = res.end;
                
                this.startDate = res.start;
                this.startHr = this.numberCorrection(res.start.getHours().toString());
                this.startMin = this.numberCorrection(res.start.getMinutes().toString());
                this.endDate = res.end;
                this.endHr = this.numberCorrection(res.end.getHours().toString());
                this.endMin = this.numberCorrection(res.end.getMinutes().toString());

                this.toggleAddBar(true);
            }
        })
    }    

    confirmReservation() {
        if (this.startHr != null && this.startMin != null) {
            var start = new Date(this.startDate.toDateString() + " " + this.startHr + ":" + this.startMin);
        } else {
            start = null;
        }

        if (this.endHr != null && this.endMin != null) {
            var end = new Date(this.endDate.toDateString() + " " + this.endHr + ":" + this.endMin);
        } else {
            end = null;
        }
        
        if (this.reservation.title != null && start != null && end != null) {
            this.reservation.start = start;
            this.reservation.end = end;

            if (this.isUpdate) {
                this.reservationService.update(this.reservation.id, this.reservation).subscribe(res => {
                    console.log(res);
                    this.clearForm();
                })
            } else {
                this.reservationService.create(this.reservation).subscribe(res => {
                    console.log(res);
                    this.clearForm();
                })
            }            
        } else {
            alert("Please make sure you've selected date and time");
        }
    }

    confirmUser() {
        if (this.user.username != null && this.user.displayname != null) {
            if (this.isUpdate) {
                this.userService.update(this.user.id, this.user).subscribe(res => {                    
                    this.clearForm();
                })
            } else {
                this.userService.create(this.user).subscribe(res => {                    
                    this.clearForm();
                })
            }
        } else {

        }        
    }

    removeUser() {
        this.dialogRef = this.dialog.open(RemoveDialogComponent, { 
            data: { 
              title: this.user.displayname,
              message: "Are you sure you want to remove this user?"
            },
            });
      
          this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.user.id != null) {
                    this.userService.delete(this.user.id).subscribe(res => {
                        this.clearForm();
                    })
                } 
            }
        });
    }

    removeReservation() {
        this.dialogRef = this.dialog.open(RemoveDialogComponent, { 
            data: { 
              title: this.reservation.title,
              message: "Are you sure you want to remove this reservation?"
            },
            });
      
          this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.reservation != null) {
                    this.reservationService.delete(this.reservation.id).subscribe(res => {
                        console.log(res);
                        this.clearForm();
                    })
                }
            }
        });
    }

    clearForm() {

        if (this.barView == "reservations") {
            this.reservation.title = "";
            this.startDate = new Date;
            this.endDate = new Date;
            this.startHr = "12";
            this.endHr = "13";
            this.startMin = "00";
            this.endMin = "00";

            this.refreshCal();
        } else if (this.barView == "users") {
            this.user = new UserModel();
            this.refreshUsers();
        }            

        this.isUpdate = false;
        this.toggleAddBar(false);        
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/views/dashboard-view/dashboard-view.component.ts